import type { ReactElement, SyntheticEvent } from "react"
import { chevronDown } from "@ionos-web-design-system/icon/system"
import { Link, Text } from "@ionos-web-design-system/react"
import useModalState from "~/hooks/useModalState"
import ProductSelectModal from "./ProductSelectModal"

type PackageSelectItem = {
  label: string
  onClick: () => void
  isActive?: boolean
}

type PackageSelectProps = {
  label: string
  items: PackageSelectItem[]
}

export default function PackageSelect({
  label,
  items,
}: PackageSelectProps): ReactElement<PackageSelectProps> {
  const { isOpen, open, close } = useModalState()

  const handleToggle = (event: SyntheticEvent) => {
    event.preventDefault()

    isOpen ? close() : open()
  }

  return (
    <div className="relative">
      <div className="text-center">
        <Text variant="bodySm">
          <Link
            concept="mono"
            icon={chevronDown}
            position="suffix"
            variant="inline"
            className="text-base font-normal"
            size="small"
            title={label}
            onClick={handleToggle}
            data-test-id="table-dropdown-link"
          >
            {label}
          </Link>
        </Text>
      </div>

      {isOpen ? (
        <ProductSelectModal
          items={items.map((item) => ({
            label: item.label,
            onClick: item.onClick,
            isActive: item.isActive ?? false,
          }))}
          onClose={close}
        />
      ) : null}
    </div>
  )
}
